import {formatEther} from "@ethersproject/units";

// export const displayCurrency = (value:any ,precision:number = 5 ) => {
//     return parseFloat(formatEther(value)).toPrecision(precision)
// }

export const displayCurrency = (value: any, decimal: number = 5) => {
  return parseFloat(formatEther(value)).toFixed(decimal)
}

export const displayCurrencyForInput = (value: any) => {
  return formatEther(value)
}

export const transformToEther = (value: any) => {
  return Number(formatEther(value))
}

export const displayEtherDecimal = (value: any, decimal: number = 2) => {
   return displayDecimal(formatEther(value) ,decimal)
}

export const  displayDecimal = (value: any, decimal: number = 2) =>{
    const cal: number = 10 ** decimal
    const output: number = Math.floor(parseFloat(value) * cal) / cal
    return output

}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}